window.onscroll = function () {
	headerScroll();
};

const header = document.querySelector(".header");
let scrollPrev = window.scrollY;
// var sticky = header.offsetTop;

function headerScroll() {
	if (window.scrollY > 50) {

		header?.classList.add("_scroll");
		if (scrollPrev > window.scrollY) {
			header?.classList.add("_view");
		} else {
			header?.classList.remove("_view");
		}
	} else {
		header?.classList.remove("_scroll");
	}
	scrollPrev = window.scrollY;
}

const menuBtn = document.querySelector('.header__menu')
const menuContent = document.querySelector('.menu__content')
const menuWrap = document.querySelector('.menu__content-wrap')
menuBtn?.addEventListener('click', (e) => {
	if (header.classList.contains('_open-menu')) {
		header.classList.remove('_open-menu');
	} else {
		header.classList.add('_open-menu');
		header.style.setProperty("--menu-height", menuContent.offsetHeight + 'px');
		header.style.setProperty("--menu-width", menuContent.offsetWidth + 'px');
	}
})
